import instance from '@/api/business' 
import { PDV } from '@/types/PDV' 

const BASE_URL = '/resale/im/PDV'

export const fetchPDV = async (SK_REVENDA: number) => {
    const response = await instance.post<PDV[]>(BASE_URL, {
        SK_REVENDA: SK_REVENDA
    })

    return response.data
} 